import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PropTypes from "prop-types";
import React from "react";

// import DialogContentText from '@material-ui/core/DialogContentText'
export default function AlertDialog({
  isOpen,
  handleClose,
  maxWidth = "md",
  title,
  children,
  onCancel = handleClose,
  cancelText = "Disagree",
  onOk = () => {},
  okText = "Ok",
}) {
  return (
    <Dialog
      open={isOpen}
      maxWidth={maxWidth}
      onClose={handleClose}
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {cancelText}
        </Button>
        <Button
          onClick={onOk}
          color="primary"
          variant="contained"
          disableElevation
          autoFocus
        >
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  onCancel: PropTypes.func,
  cancelText: PropTypes.string,
  onOk: PropTypes.func,
  okText: PropTypes.string,
};
